import React, {Component} from 'react'
import {authenticationService} from '../../../services/AuthenticationService';

import SvGraphics from "../../../assets/SvGraphics";
import * as Yup from "yup";
import validationHelper from "../../../utils/validationHelper";
import utils from "../../../utils/utils";
import Error from "../../../components/single_components/Error";
import Config from "../../../config/Config";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import ReCaptcha from "../ReCaptcha";

class Login2FAComposed extends Component {
    constructor(props) {
        super(props);

        if (!authenticationService.currentMfaUserValue) {
            this.props.history.push('/');
        }
        this.recaptchaRef = React.createRef()

        this.state = {
            twoFA: '',
            auth: {},
            isErr: false,
            errMessage: '',
            errors: {},
            errorsOnSave: {},
        }
    }

    initValidation = async () => {
        let {t} = this.props
        let validationSchema = Yup.object().shape({twoFA: Yup.string().required(t('defaults.TwoFA.auth_cd_req'))})
        let errors = await validationHelper.validate(this.state.auth, validationSchema)
        await this.setState({
            validationSchema,
            errors
        })
    }

    async componentWillMount() {
        await this.initValidation()
    }

    onSubmit = async () => {
        let isLocal = process.env.REACT_APP_ENV === 'localhost'

        if (!isLocal) {
            await this.recaptchaRef.reset()
            await this.recaptchaRef.execute()
        } else {
            await this.submitData("NOTOKENINLOCAL");
        }

    }
    submitData = async (reCaptchaToken) => {
        if (!utils.isEmpty(this.state.errors)) {
            this.setState({errorsOnSave: this.state.errors});
            return;
        }
        let {twoFA} = this.state
        let response = await authenticationService.submit2fa(twoFA, reCaptchaToken);
        if (response.status < 400) {
            let data = response.data
            if (data && data.hasOwnProperty('status') && String(data['status']).toLowerCase() === 'pass') {
                if (data.hasOwnProperty('updatePassword') && data['updatePassword'] === true) {
                    const {from} = {from: {pathname: "/create-password"}};
                    this.props.history.push(from);
                } else if (data.hasOwnProperty('updatePassword') && data['updatePassword'] === false) {
                    const {from} = {from: {pathname: "/dashboard"}};
                    this.props.history.push(from);
                }
            } else {
                await this.setUserName({target: {value: ''}})
                await this.setPassword({target: {value: ''}})
                this.setState({
                    twoFA: '',
                    isErr: true,
                    errMessage: response.data ? 'Wrong Code' : 'No connection to server',
                })
            }
        } else {
            this.setState({
                twoFA: '',
                isErr: true,
                errMessage: response.data ? 'Wrong Code' : 'No connection to server',
            })
        }
    }

    setMFA = async (e) => {
        let {auth, validationSchema} = this.state
        this.setState({twoFA: e.target.value.trim()})
        utils.set(auth, 'twoFA', e.target.value.trim())
        let errors = await validationHelper.validate(auth, validationSchema);
        let errorsOnSave = this.state.errorsOnSave;
        if (utils.get(errorsOnSave, 'twoFA')) {
            utils.set(errorsOnSave, 'twoFA', utils.get(errors, 'twoFA'))
        }
        this.setState({
            auth,
            errors,
            errorsOnSave,
            isErr: false, errMessage: ''
        })
    }

    render() {
        let {t} = this.props
        return (
            <div className={"login-page"}>
                <div className={'h-centered sade-login-logo-container'}>
                    <SvGraphics svgname={'asaya_logo'} className={'sade-asaya-login-logo'} style={{width: '300px'}}/>
                </div>
                <div className={'centered sade-login-main-board'}>
                    <label className={'sade-login-label'}>{t('defaults.TwoFA.TwoFA')}</label>
                    <label className={'h-centered sade-validation-label'}>{t('defaults.TwoFA.TwoFA_info')}</label>
                    <div className={'sade-login-form-container'}>
                        <div className={'h-centered sade-login-form'}>
                            <Error isNonFloat={true} errorMessage={utils.get(this.state.errorsOnSave, 'mfa')}
                                   isShown={!!utils.get(this.state.errorsOnSave, 'mfa')}/>
                            <div className={"login-input-wrapper form-group sade-login-form-group"}>
                                <input className={"sade-input sade-form-input sade-login-input-field"}
                                       placeholder={t('defaults.TwoFA.valid_cd')}
                                       type={"text"}
                                       name={"twoFA"}
                                       value={this.state.twoFA}
                                       onChange={e => this.setMFA(e)}
                                       onKeyPress={event => {
                                           if (event.key === 'Enter') {
                                               this.onSubmit()
                                           }
                                       }}/>
                                <SvGraphics className={"input-pic"} svgname={'lock'}
                                            style={{width: '20px', height: '20px'}}/>
                            </div>
                            <div className="form-group sade-login-form-group">
                                <button className="btn h-centered btn-primary sade-login-form-button"
                                        onClick={this.onSubmit}>{t('defaults.TwoFA.valid')}</button>
                            </div>

                        </div>
                    </div>
                    <div className={'sade-login-form-group loginError red h-centered'}>
                        <Error isNonFloat={true}
                               errorMessage={t('defaults.TwoFA.auth_err') + ': ' + this.state.errMessage}
                               isShown={this.state.isErr}/>
                    </div>
                    <div className={'h-centered sade-login-footer-container'}
                         onClick={() => this.props.history.goBack()}>
                        <a>{t('defaults.TwoFA.back_to_login')}</a>
                    </div>
                </div>
                {/*    <div className={'h-centered sade-asaya-login-logo-container'}>
                    <SvGraphics svgname={'sade_logo'} className={'sade-login-logo'} style={{width:'340px'}}/>
                </div>*/}

                <div className={'login-version-element'}>
                        <div className={'login-version-element-label'}>Version:</div>
                        <div className={'login-version-element-value'}>{Config.version} {Config.build}</div>
                    </div>
                <ReCaptcha setRef={ref => (this.recaptchaRef = ref)}
                           action={async (reCaptchaToken) => {
                               await this.submitData(reCaptchaToken);
                           }}
                    /*setErr={ this.setRecapchaErrors()}*//>
            </div>

        )
    }
}

let Login2FA = compose(
    withTranslation()
)(Login2FAComposed)

export default Login2FA;
